import clsx from "clsx";
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  formControl: {
    fontSize: 12,
    padding: "9px 12px",
    height: "100%",
    color: "#66615b",
    width: "100%",
    display: "flex",
    alignItems: "center",
    "&.Mui-disabled": {
      opacity: 0.3,
    },
  },
  inputLabelText: {
    fontSize: 12,
    "&:not(.MuiInputLabel-shrink)": {
      transform: "translate(14px, 9px) scale(1)",
    },
  },
}));

const MultiColumnSelect = ({
  onChange,
  value,
  options,
  disabled,
  inputLabel,
  name,
  customClass,
  shrink,
  size,
  formControlClass,
  id,
  inputProps: inputPropsProp,
  required,
  fullWidth,
}) => {
  const classes = useStyles();

  const defaultInputSx = {
    padding: "unset",
    paddingRight: "16px !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <FormControl
      required={required}
      className={customClass}
      variant="outlined"
      size={size}
      fullWidth={fullWidth}
    >
      <InputLabel shrink={shrink} size={size} className={classes.inputLabelText}>
        {inputLabel}
      </InputLabel>
      <Select
        id={id}
        onChange={onChange}
        value={value}
        disabled={disabled}
        name={name}
        fullWidth={fullWidth}
        input={<OutlinedInput label={inputLabel} />}
        variant="outlined"
        className={clsx(classes.formControl, formControlClass)}

        inputProps={{
          ...inputPropsProp,
          sx: {
            ...defaultInputSx,
            ...(inputPropsProp?.sx || {}),
          }
        }}
      >
        {options.map((workspace, i) => (
          <MenuItem
            key={workspace.name + i}
            value={workspace.workspaceTemplateId}
          >
            <ListItemText secondary={workspace.description}>
              {workspace.name}
            </ListItemText>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MultiColumnSelect.defaultProps = {
  disabled: false,
  name: "",
  value: "",
  inputLabel: null,
  inputProps: {},
  customClass: "",
  size: "normal",
  fullWidth: true,
};

export default MultiColumnSelect;
